import ThankYou from "@pages/contact/parts/thank-you";
import { API_BASE_URL, RECAPTCHA_SITE_KEY } from "@utils/constant";
import { triggerEachFormTracker } from "@utils/helper";
import axios from "axios";
import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import ReCAPTCHA from "react-google-recaptcha";
import { SubmitHandler, useForm } from "react-hook-form";
import { RxCrossCircled } from "react-icons/rx";

const DemoPopup = ({ show, onClose }) => {
  const recaptchaRef = React.useRef<ReCAPTCHA>();
  const params = new URLSearchParams(window.location.search);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    brand_url: "",
    g_recaptcha_token: "",
    form_type: ""
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { handleSubmit, getValues } = useForm({});

  if (!show) return null;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Allow only + and digits in mobile
    if (name === "mobile" && /[^\d+]/.test(value)) return;

    if (name === "daily_order") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        sub_platform: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!formData.name.trim())
      newErrors.name = "Full name is required.";

    if (!formData.mobile.trim())
      newErrors.mobile = "Phone number is required.";
    else if (!/^\+?\d{7,15}$/.test(formData.mobile.trim()))
      newErrors.mobile = "Enter a valid Phone number.";

    if (!formData.email.trim()) newErrors.email = "Email Id is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email id.";

    if (!formData.brand_url.trim()) {
      newErrors.brand_url = "Website URL is required.";
    }




    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleRecaptchaChange = (value) => {
    formData.g_recaptcha_token = value;
    formData.form_type = "Checkout V1"
    axios
      .post(API_BASE_URL + "form/shopify/checkv1", formData)
      .then(function (response) {
        setSuccessMessage("Demo booked successfully!");
        triggerEachFormTracker(formData)
        setFormData({
          name: formData.name,
          mobile: "",
          email: "",
          brand_url: "",
          g_recaptcha_token: "",
          form_type: ""
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error.response.data?.errors["product[]"]);
        setErrors(error?.response?.data?.errors);
      });
  };

  const handleRecaptchaSubmit = async () => {
    // Trigger the reCAPTCHA challenge
    recaptchaRef.current.execute();
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    setSuccessMessage("");
    if (!validateForm()) return;

    data.source = params.get("utm_source");
    data.medium = params.get("utm_medium");
    data.campaign = params.get("utm_campaign");

    data.campaignid = params.get("campaignid");
    data.adgroupid = params.get("adgroupid");
    data.keyword = params.get("keyword");
    data.utm_term = params.get("utm_term");
    data.gad_source = params.get("gad_source");
    data.gad_campaignid = params.get("gad_campaignid");
    data.gbraid = params.get("gbraid");
    data.gclid = params.get("gclid");
    setFormData(prevData => ({
      ...prevData,
      ...data
    }));
    handleRecaptchaSubmit();
  };
  // export const SectionOne = () => {

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="close-btn" onClick={onClose}>
          <RxCrossCircled size={28} />
        </button>

        {/* Form */}
        {/* <form className="popup-form"> */}
        {successMessage && (
          <Fade direction="right">
            <ThankYou name={formData?.name} />
          </Fade>
        )}
        {
          !successMessage &&
          <form
            className="popup-form"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Full Name" />
            {errors.name && (
              <p className="error" style={{ color: "red" }}>
                {errors.name}
              </p>
            )}

            {/* <input type="text" placeholder="Phone Number" /> */}
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Phone Number"
            />
            {errors.mobile && (
              <p className="error" style={{ color: "red" }}>
                {errors.mobile}
              </p>
            )}

            {/* <input type="email" placeholder="Email Id" /> */}
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
            />
            {errors.email && (
              <p className="error" style={{ color: "red" }}>
                {errors.email}
              </p>
            )}

            {/* <input type="text" placeholder="Ecommerce Store link" /> */}
            <input
              type="url"
              id="brand_url"
              name="brand_url"
              value={formData.brand_url}
              onChange={handleChange}
              placeholder="Ecommerce Store link"
            />
            {errors.brand_url && (
              <p className="error" style={{ color: "red" }}>
                {errors.brand_url}
              </p>
            )}

            {/* <select>
            <option>Type of eCommerce platform</option>
            <option>Shopify</option>
            <option>WooCommerce</option>
            <option>Magento</option>
          </select> */}
            <ReCAPTCHA
              ref={recaptchaRef as React.RefObject<ReCAPTCHA>}
              sitekey={RECAPTCHA_SITE_KEY}
              size="invisible"
              onChange={handleRecaptchaChange}
            />
            {/* <button type="submit" className="submit-btn">
            Book a Demo
          </button> */}
            <button type="submit" disabled={loading} className="submit-btn">
              {loading ? "Submitting..." : "Book a Demo"}
            </button>
          </form>
        }
      </div>
    </div>
  );
};

export default DemoPopup;
